import React from 'react'
import { Table } from 'antd';
import { NavLink } from 'react-router-dom';

function SubAgentCommissionList({ subAgentCommissions =  [{ commissions_calc: { credit: 0, debt: 0, balance: 0} }]}) {

    const columns = [
                {
                    title: "סוכן משנה",
                    key: "subAgent",
                    align: "right",
                    render: (_, record) => <NavLink to={`/agents/${record.id}`}>{`${record.id}  -  ${record.first_name} ${record.last_name}`}</NavLink>
                },
                {
                    title: "זיכוי",
                    key: "credit",
                    align: "right",
                    render: (_, record) => <span style={{ color: 'green' }}>{record.commissions_calc.credit.toFixed(1)}</span>
                },
                {
                    title: "חיוב",
                    key: "debt",
                    align: "right",
                    render: (_, record) => <span style={{ color: "red" }}>{record.commissions_calc.debt.toFixed(1)}</span>
                },
                {
                    title: "יתרה",
                    key: "balance",
                    align: "right",
                    render: (_, record) => <span
                                                style={{ color: `${record.commissions_calc.balance < 0 ? "red" : "green"}` }}
                                            >
                                                {record.commissions_calc.balance.toFixed(1)}
                                            </span>
                }
            ]

    return (
        <Table 
                dataSource={subAgentCommissions}
                columns={columns}
                rowKey="id"
            />
    )
}

export default SubAgentCommissionList


